import styled from '@emotion/styled';
import { Colors } from '../../../../colors';

export const CsvModalStyle = {
  ModalContainerContent: styled.div`
    background-color: ${Colors.White};
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 3px;
    outline:none;
  `,
  ContentModal: styled.div`
    min-width: 488px;
    min-height: 358px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 18px
    
  `,
  ContainerCloseButton: styled.div<any>`
    display: flex;
    align-self: end;
    justify-self: end;
    margin-bottom: 10px
  `,
  TitleModal: styled.p`
    font-family: EncodeSans-Medium;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  `,
  SubTitleModalContainer: styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 67px;
  `,
  SubTitleModal: styled.p`
    font-family: EncodeSans-Medium;
    font-size: 16px;
    text-align: center;
    margin-top: 12px
  `,

  UploadIcon: styled.img<any>`
   margin-bottom: 14px;  
   width:43px;
   height:56px;
  `,
  TextModalContainer: styled.label`
   cursor: pointer;
   display:flex;
   flex-direction:column;
   align-items:center;
  `,
  TextModalUnderline: styled.text`
   text-decoration: underline;
   font-family: EncodeSans-Medium;
   font-size: 14px;
   font-weight:500;
  `,
  TextModal: styled.text`
    font-family: EncodeSans-Medium;
    font-size: 14px;
    font-weight:500;
    margin-top: 13px
  `,
  TextModalOverride: styled.text`
    font-family: EncodeSans-Medium;
    font-size: 14px;
    font-weight: 500;
  `,
};
